import { render, staticRenderFns } from "./OverlayHeader.vue?vue&type=template&id=3f707f4a"
import script from "./OverlayHeader.vue?vue&type=script&lang=js"
export * from "./OverlayHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports